// extracted by mini-css-extract-plugin
export default {"intellect-card-blogger":"index_intellect-card-blogger__j50eK"};